import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import axiosInstance from '@/lib/axios'
import { KpiWidget } from './KpiWidget'

export function KpiWoInLavorazioneWidget() {
  const navigate = useNavigate()
  const { data, isLoading } = useQuery<number>({
    queryKey: ['dashboard', 'wo-in-lavorazione-count'],
    queryFn: async () => {
      const res = await axiosInstance.get('/work-orders/', { params: { stato: 'in lavorazione', limit: 1 } })
      return res.data?.total ?? 0
    },
    staleTime: 30000,
  })
  return (
    <KpiWidget
      title="OdL in lavorazione"
      value={data}
      loading={isLoading}
      color="#1677ff"
      onClick={() => navigate('/schede-lavoro?stato=in+lavorazione')}
    />
  )
}
